import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, ModalController, ModalOptions } from 'ionic-angular';
import {AutoCompleteComponent} from 'ionic2-auto-complete';
import { MovimientocarteraServiceProvider} from '../../providers/movimientocartera-service/movimientocartera-service';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import { EntidadServiceProvider} from '../../providers/entidad-service/entidad-service';
import { EnviocorreoPage } from '../enviocorreo/enviocorreo';
import { TranslateService } from '@ngx-translate/core'
/**
 * Generated class for the ComprobantesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-comprobantes',
  templateUrl: 'comprobantes.html',
})
export class ComprobantesPage {

  @ViewChild('proveedor') proveedor: AutoCompleteComponent

  auxreporte:{desde:String, hasta:String };
  fechaDesde:Date= new Date();
  listcac_movcar=[];
  entidad={id:0, descripcion:'', idtusuario:0};

  constructor(public navCtrl: NavController, public navParams: NavParams, public movcarService : MovimientocarteraServiceProvider,
  	public loadingCtrl: LoadingController, public authService : AuthServiceProvider, public modalCtrl: ModalController,
    public entidadService: EntidadServiceProvider,
    private translateService: TranslateService, public alertCtrl: AlertController) {
    this.entidadService.idtentidad = 2; //CONDOMINOS
    
    this.entidad.idtusuario = this.authService.usuario['idtusuario'];
    //if(this.entidad.idtusuario == 1){
      this.entidad.id = this.authService.usuario['identidad'];
      this.entidad.descripcion = this.authService.usuario['entidad'];
    //}


  	var tzoffset = (new Date()).getTimezoneOffset() * 60000;

    this.fechaDesde = new Date(Date.now() - tzoffset);
    this.fechaDesde.setDate( this.fechaDesde.getDate()-365 )
    this.auxreporte={desde: this.fechaDesde.toISOString(), hasta: (new Date(Date.now() - tzoffset)).toISOString() };
  }

  seleccionarIdioma(){
    let alert = this.alertCtrl.create();
    alert.setTitle('Select a language');

    alert.addInput({
      type: 'radio',
      label: 'English',
      value: 'en',
      checked: true
    });

    alert.addInput({
      type: 'radio',
      label: 'Español',
      value: 'es'
    });
    
    alert.addButton('Cancel');
    alert.addButton({
      text: 'OK',
      handler: data => {
        this.translateService.use(data);
      }
    });
    alert.present();
  }

  ionViewDidLoad() {
  }

  buscar(){
  	let loading = this.loadingCtrl.create({
  	content: 'Cargando, espere por favor...'
  	});
  	loading.present();
    console.log(this.entidad.id);
  	this.movcarService.getFecha(this.entidad.id, this.auxreporte.desde, this.auxreporte.hasta).subscribe(val => {
      console.log(val);
    	this.listcac_movcar = [];
    	for (var i = 0; i < val.length; i++) {
    	  this.listcac_movcar.push(val[i]);
    	}
    	loading.dismiss();
  	});
  }

  imprimirItem(params){

  	let loading = this.loadingCtrl.create({
      content: 'Cargando, espere por favor...'
    });

    loading.present();

    this.movcarService.getReporte(params.idempresa, params.id).then(data=>{
      const myModalOptions: ModalOptions = {
        enableBackdropDismiss: false,
        cssClass : 'modal-correo'
      }
      params.correo = (data["identidadd"] == null) ? data["correop"] : data["correod"];
      params.entidad = (data["identidadd"] == null) ? data["proveedor"] : data["destinatario"];

      let modal = this.modalCtrl.create(EnviocorreoPage, params, myModalOptions);
      modal.present();
      loading.dismiss();
    },(err) => {
        loading.dismiss();
     });
  }

  seleccionarProveedor(evento)
  {
    
    let descripcion = evento.descripcion;
    //if(this.entidad.idtusuario != 1){
      this.proveedor.setValue(descripcion);
      this.entidad.descripcion = descripcion;
      this.entidad.id = evento.id;
    //}
  }
}



// WEBPACK FOOTER //
// ./src/pages/comprobantes/comprobantes.ts